// extracted by mini-css-extract-plugin
export default {"ProfileMenuItem":"ProfileMenuItem_ProfileMenuItem__NTB+-"};